import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";

import { useAuth } from "./../AuthContext";

import "./../styles/dashboardPro.css";

const Navbar = ({ toggleSidebar }) => {
  const { logout } = useAuth();
  const router = useNavigate();

  const [darkMode, setDarkMode] = useState(false);

  const handleLogout = () => {
    logout();
    router("/login");
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
  }, [darkMode]);

  return (
    <nav className={`top-navbar ${darkMode ? "dark" : ""}`}>
      <div className="top-navbar-container">

        {/* LEFT */}
        <div className="navbar-left">

          {/* MENU BUTTON */}
          <button
            onClick={toggleSidebar}
            className="navbar-icon-btn"
          >
            <i className="bi bi-list"></i>
          </button>

          {/* TITLE */}
          <div className="navbar-title-wrapper">
            <span className="navbar-title">
              Zalud Clinical Dashboard
            </span>

            <small className="navbar-subtitle">
              Gestión médica inteligente
            </small>
          </div>

        </div>

        {/* RIGHT */}
        <div className="navbar-right">

          {/* DARK MODE */}
          <div
            className={`theme-switch ${darkMode ? "active" : ""}`}
            onClick={() => setDarkMode(!darkMode)}
          >
            <div className="theme-switch-ball">
              {darkMode ? "🌙" : "☀️"}
            </div>
          </div>

          {/* NOTIFICATIONS */}
          <button className="navbar-icon-btn position-relative">

            <i className="bi bi-bell"></i>

            <span className="notification-dot"></span>

          </button>

          {/* USER MENU */}
          <UncontrolledDropdown>

            <DropdownToggle
              className="navbar-user-btn"
              caret={false}
            >
              <div className="user-avatar w-2">
                <i className="bi bi-person-fill mx-1 "></i>
                <i className="bi bi-chevron-down user-chevron"></i>
              </div>

              {/* <div className="user-info d-none d-md-flex">
                <span className="user-name">
                  Usuario
                </span>

                <small className="user-role">
                  Administrador
                </small>
              </div> */}

              

            </DropdownToggle>

            <DropdownMenu
              end
              className="navbar-dropdown"
            >

              <DropdownItem tag={NavLink} to="/profile">
                <i className="bi bi-person"></i>
                Perfil
              </DropdownItem>

              <DropdownItem>
                <i className="bi bi-gear"></i>
                Configuración
              </DropdownItem>

              <DropdownItem>
                <i className="bi bi-life-preserver"></i>
                Soporte
              </DropdownItem>

              <DropdownItem divider />

              <DropdownItem
                onClick={handleLogout}
                className="logout-item"
              >
                <i className="bi bi-box-arrow-right"></i>
                Cerrar sesión
              </DropdownItem>

            </DropdownMenu>

          </UncontrolledDropdown>

        </div>
      </div>
    </nav>
  );
};

export default Navbar;